import api from "../../Services/api";
import React, { useEffect, useState } from "react";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Form, Row, Col } from 'react-bootstrap';
import GridRegistros from "../../Componentes/GridRegistros";
import { EProcessoSituacao } from "../../Enum/Enum";
import "./index.css";

const CadastroCliente = () => {

  const PROCESSOS_INICIAIS = [
    { IDProcesso: null, nome: "Guarda Documental", chave: "guardaDocumental", ativo: false },
    { IDProcesso: null, nome: "Governança", chave: "governanca", ativo: false },
    { IDProcesso: null, nome: "Auditoria", chave: "auditoria", ativo: false },
    { IDProcesso: null, nome: "Audit. Patrimonial", chave: "patrimonial", ativo: false },
    { IDProcesso: null, nome: "Planejamento Estratégico", chave: "planejamento", ativo: false }
  ];

  const [idClienteEditando, setIdClienteEditando] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [processosSelecionados, setProcessosSelecionados] = useState(PROCESSOS_INICIAIS);

  const [cliente, setCliente] = useState({
    nome: "",
    cnpj: "",
    observacao: "",
    logradouro: "",
    numeroEnd: "",
    bairro: "",
    municipio: "",
    uf: "",
    complementoEnd: "",
    dataCadastro: new Date().toISOString().split("T")[0],
    situacao: 1
  });

  const { authReady } = useAuthContext();
  const { IDOperador, nome, permissaoPrincipal, operador } = useOperador();

  const navigate = useNavigate();
  let idFormatado = String(IDOperador).padStart(6, '0');

  useEffect(() => {
    if (!operador && !authReady) {
      navigate("/");
    }

    carregarClientes();
  }, [operador]);

  const carregarClientes = async () => {
    try {
      const res = await api.get("/clientes");
      const clientesFormatados = res.data.map((cliente) => ({
        ...cliente,
        situacao: cliente.situacao === 1 ? "Ativo" : "Cancelado",
      }));
      setClientes(clientesFormatados);
    } catch (err) {
      console.error("Erro ao carregar clientes", err);
      exibirErrosValidacao(err, "Erro");
    }
  };

  const solicitaConfirmacao = async () => {
    const { isConfirmed, value } = await Swal.fire({
      title: 'Processo vinculado a operadores',
      text: 'Existem operadores vinculados a processos cancelados. Caso prossiga, este vínculo será encerrado. Para continuar, digite "CONFIRMAR".',
      input: 'text',
      inputPlaceholder: 'Digite "CONFIRMAR" para prosseguir',
      inputValidator: (value) => {
        if (value.toUpperCase() !== 'CONFIRMAR') {
          return 'Você precisa digitar exatamente "CONFIRMAR".';
        }
      },
      inputAttributes: {
        style: 'max-width: 87%; box-sizing: border-box;'
      },
      customClass: {
        input: 'swal-input-ajustado',
        cancelButton: 'swal-cancel-danger',
      },
      icon: 'question',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: 'var(--color-btnCancelar-danger)',
      confirmButtonText: 'Deletar operadores e processo',
    });

    // Retorna true somente se ele confirmou e digitou corretamente
    return isConfirmed && value.toUpperCase() === 'CONFIRMAR';
  };

  const salvarProcessos = async (idCliente, edicao) => {
    console.log('Edição?', !!edicao);

    for (const processo of processosSelecionados) {
      const { ativo, IDProcesso, nome } = processo;

      try {
        if (!ativo && IDProcesso && edicao) {
          await api.put(`/processo/${IDProcesso}/situacao`, { situacao: EProcessoSituacao.INATIVO });
          console.log(`⚠️ Processo "${nome}" inativado.`);
          continue;
        }

        if (ativo) {
          if (IDProcesso) {
            // Consulta Processo
            const processoBD = await api.get(`/processo/${IDProcesso}`);
            if (processoBD.data.Processo && processoBD.data.Processo.situacao === EProcessoSituacao.INATIVO) {
              await api.put(`/processo/${IDProcesso}/situacao`, { situacao: EProcessoSituacao.ATIVO });
              console.log(`✔️ Processo "${nome}" reativado`);
              continue;
            }
            // Verifica se há bucket associado            
            const nomeBucketAws = processoBD?.data?.Processo?.nomeBucketAws;
            if (!nomeBucketAws) {
              const criaBucket = await api.post('/create-bucket', {
                bucketName: processoBD.data.Processo.nomeBucketAws,
                tipoPermissao: permissaoPrincipal ?? 99
              });
              console.log('🪣 Bucket criado (reativação)', criaBucket);

              //Cria diretorio para Planejamento Estratégico
              if (processoBD.data.Processo.chave === 'planejamento') {
                await api.post("/diretorio", {
                  IDProcesso: IDProcesso,
                  IDCriador: IDOperador,
                  descricao: "Planejamento Estratégico",
                  descricaoExibicao: "Planejamento Estratégico",
                  IDPai: 0,
                  IDFilho: 0,
                  nomeBucketAws: processoBD.data.Processo.nomeBucketAws,
                  tipo: "1",
                  situacao: 1,
                });
              }
            }
          } else {
            // Se ainda não existe, cria processo
            const body = {
              IDCliente: idCliente,
              descricao: nome,
              observacao: "",
              situacao: 1,
            };
            const insertRes = await api.post('/processo', body);
            console.log(`✔️ Processo "${nome}" cadastrado`, insertRes.data);

            // Cria bucket se necessário            
            if (insertRes.data?.IDProcesso && insertRes.data?.nomeBucketAws) {
              const criaBucket = await api.post('/create-bucket', {
                bucketName: insertRes.data.nomeBucketAws,
                tipoPermissao: permissaoPrincipal ?? 99
              });
              console.log('🪣 Bucket criado com sucesso', criaBucket);
            }

            if (nome === 'Auditoria') {
              //Cria diretorio para anexos de Auditoria
              await api.post("/diretorio", {
                IDProcesso: insertRes.data.IDProcesso,
                IDCriador: IDOperador,
                descricao: "Anexos-Auditoria",
                descricaoExibicao: "Anexos de Auditoria",
                IDPai: 0,
                IDFilho: 0,
                nomeBucketAws: insertRes.data.nomeBucketAws,
                tipo: "1",
                situacao: 1,
              });
            }


          }
        }

      } catch (err) {
        console.error(`❌ Erro ao processar "${nome}"`, err);
        Swal.fire(`Erro no processo "${nome}"`, err.message || "", "error");
      }
    }
  };


  const salvarCliente = async () => {
    const camposObrigatorios = ["nome", "cnpj", "logradouro", "numeroEnd", "bairro", "municipio", "uf"];
    for (let campo of camposObrigatorios) {
      if (!cliente[campo]) {
        alert(`O campo ${campo} é obrigatório.`);
        return;
      }
    }

    const cnpjSemMascara = String(cliente.cnpj || "").replace(/\D/g, "");
    if (cnpjSemMascara.length !== 14) {
      Swal.fire("CNPJ invalido", "O CNPJ deve conter 14 digitos.", "warning");
      return;
    }

    const cnpjDuplicado = clientes.some(
      (item) =>
        String(item.cnpj || "").replace(/\D/g, "") === cnpjSemMascara &&
        Number(item.IDCliente) !== Number(idClienteEditando)
    );

    if (cnpjDuplicado) {
      Swal.fire("CNPJ ja cadastrado", "Ja existe um cliente cadastrado com este CNPJ.", "warning");
      return;
    }

    try {
      const clientePayload = { ...cliente, cnpj: cnpjSemMascara };
      if (idClienteEditando) {
        await api.put(`/cliente/${idClienteEditando}`, clientePayload);
        //alert("Cliente editado com sucesso!");
        await salvarProcessos(idClienteEditando, 1);
      } else {
        const result = await api.post("/cliente", clientePayload);
        if (result) await salvarProcessos(result.data.IDCliente, 0);
      }
      carregarClientes();
      setIdClienteEditando(null);
      resetarFormulario();
      setProcessosSelecionados(PROCESSOS_INICIAIS);
    } catch (err) {
      console.error("❌ Erro ao salvar cliente:", err);
      if (err.response) {
        console.error("📩 Erro da API:", {
          status: err.response.status,
          data: err.response.data,
        });

        const bodyErrors = err.response.data?.erros?.body;

        if (bodyErrors) {
          const mensagens = Object.entries(bodyErrors)
            .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
            .join("<br>");

          Swal.fire({
            title: "Erro de validação",
            html: mensagens,
            icon: "error"
          });
        } else {
          const mensagem =
            err.response.data?.errors?.default ||
            err.response.data?.message ||
            "Erro inesperado ao salvar cliente.";

          Swal.fire("Erro", mensagem, "error");
        }
      } else {
        alert("Erro inesperado ao salvar cliente. Verifique o console.");
      }
    }
  };

  const consultaVinculoOperadorProcesso = async (IDProcesso) => {
    try {
      const res = await api.get(`/processo/operador-processo/${IDProcesso}`);
      if (res.data && Object.keys(res.data)) {
        return res.data;
      }
    } catch (error) {
      console.log("Houve uma falha ao consultar operadores vinculados ao processo");
    }
  }

  const handleSwitchChange = async (e) => {
    const { name, checked } = e.target;

    const novosProcessos = [];
    for (const p of processosSelecionados) {
      let novoProcesso = { ...p };

      if (p.chave === name) {
        if (idClienteEditando && p.IDProcesso && !checked) {
          const consulta = await consultaVinculoOperadorProcesso(p.IDProcesso);
          if (consulta && Object.keys(consulta).length > 0) {
            const confirmacao = await solicitaConfirmacao();
            if (!confirmacao) {
              novosProcessos.push(p); // não altera
              continue;
            }
          }
        }
        novoProcesso.ativo = checked;
      }
      novosProcessos.push(novoProcesso);
    }
    setProcessosSelecionados(novosProcessos);
  };

  const handleEdit = (cliente) => {
    setIdClienteEditando(cliente.IDCliente);

    setCliente({
      nome: cliente.nome,
      cnpj: cliente.cnpj,
      logradouro: cliente.logradouro,
      numeroEnd: cliente.numeroEnd,
      bairro: cliente.bairro,
      municipio: cliente.municipio,
      uf: cliente.uf,
      complementoEnd: cliente.complementoEnd || "",
      observacao: cliente.observacao || "",
      situacao: cliente.situacao === "Ativo" ? 1 : 0,
      dataCadastro: new Date(cliente.dataCadastro).toISOString().split("T")[0],
    });

    carregarProcessosDoCliente(cliente.IDCliente); //<-- Carrega os processos e marca os checks
  };

  const exibirErrosValidacao = (err, titulo = "Erro") => {
    const bodyErrors = err.response?.data?.erros?.body;

    if (bodyErrors) {
      const mensagens = Object.entries(bodyErrors)
        .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
        .join("<br>");

      Swal.fire({
        title: titulo,
        html: mensagens,
        icon: "error"
      });
    } else {
      Swal.fire(titulo, "Erro inesperado ao processar requisição.", "error");
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/cliente/${id}`);
      if (res.status === 204) {
        alert("Registro excluído com sucesso!");
        carregarClientes();
      } else {
        console.log(res);
        alert("Erro ao excluir.");
      }
    } catch (err) {
      console.log(err);
      alert("Erro na comunicação com o servidor.");
      exibirErrosValidacao(err, "Erro");
    }
  };

  function resetarFormulario() {
    setCliente({
      nome: "",
      cnpj: "",
      observacao: "",
      logradouro: "",
      numeroEnd: "",
      bairro: "",
      municipio: "",
      uf: "",
      complementoEnd: "",
      dataCadastro: new Date().toISOString().split("T")[0],
      situacao: 1
    });
    setProcessosSelecionados(PROCESSOS_INICIAIS);
  }

  const carregarProcessosDoCliente = async (idCliente) => {
    try {
      const guardaRes = await api.get(`/processoClienteTipo/${idCliente}/Guarda`);
      const governanca = await api.get(`/processoClienteTipo/${idCliente}/Govern`);
      const auditoriaRes = await api.get(`/processoClienteTipo/${idCliente}/Auditoria`);
      const patrimonioRes = await api.get(`/processoClienteTipo/${idCliente}/Patrimon`);
      const planjRes = await api.get(`/processoClienteTipo/${idCliente}/Planej`);

      setProcessosSelecionados(prev =>
        prev.map(p => {
          if (p.chave === "guardaDocumental") {
            const processo = guardaRes.data[0];
            return { ...p, ativo: processo?.situacao === 1, IDProcesso: processo?.IDProcesso || null };
          }
          if (p.chave === "governanca") {
            const processo = governanca.data[0];
            return { ...p, ativo: processo?.situacao === 1, IDProcesso: processo?.IDProcesso || null };
          }
          if (p.chave === "auditoria") {
            const processo = auditoriaRes.data[0];
            return { ...p, ativo: processo?.situacao === 1, IDProcesso: processo?.IDProcesso || null };
          }
          if (p.chave === "planejamento") {
            const processo = planjRes.data[0];
            return { ...p, ativo: processo?.situacao === 1, IDProcesso: processo?.IDProcesso || null };
          }
          if (p.chave === "patrimonial") {
            const processo = patrimonioRes.data[0];
            return { ...p, ativo: processo?.situacao === 1, IDProcesso: processo?.IDProcesso || null };
          }
          return p;
        })
      );
    } catch (err) {
      console.error('❌ Erro ao carregar processos do cliente:', err);
      setProcessosSelecionados(PROCESSOS_INICIAIS);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setCliente((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />
        <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>CLIENTES</h4>

        <div className="container mt-3 px-5">
          {/* Nome, CNPJ */}
          <div className="form-row">
            <div className="form-group" style={{ flex: 2 }}>
              <label>CNPJ</label>
              <input
                type="text"
                name="cnpj"
                value={cliente.cnpj || ""}
                onChange={handleChange}
                placeholder="Digite o CNPJ"
                maxLength={14}
              />
            </div>
            <div className="form-group" style={{ flex: 4 }}>
              <label>Nome</label>
              <input
                type="text"
                name="nome"
                value={cliente.nome || ""}
                onChange={handleChange}
                placeholder="Digite o Nome"
              />
            </div>
          </div>

          {/* Logradouro + Número */}
          <div className="form-row">
            <div className="form-group" style={{ flex: 4 }}>
              <label>Logradouro</label>
              <input
                type="text"
                name="logradouro"
                value={cliente.logradouro || ""}
                onChange={handleChange}
                placeholder="Digite o logradouro"
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Número</label>
              <input
                type="text"
                name="numeroEnd"
                value={cliente.numeroEnd || ""}
                onChange={handleChange}
                placeholder="Número"
              />
            </div>
          </div>

          {/* Bairro + Município + UF */}
          <div className="form-row">
            <div className="form-group" style={{ flex: 2 }}>
              <label>Bairro</label>
              <input
                type="text"
                name="bairro"
                value={cliente.bairro || ""}
                onChange={handleChange}
                placeholder="Bairro"
              />
            </div>
            <div className="form-group" style={{ flex: 2 }}>
              <label>Município</label>
              <input
                type="text"
                name="municipio"
                value={cliente.municipio || ""}
                onChange={handleChange}
                placeholder="Município"
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>UF</label>
              <input
                type="text"
                name="uf"
                value={cliente.uf || ""}
                onChange={handleChange}
                placeholder="UF"
                maxLength={2}
              />
            </div>
          </div>

          {/* Complemento + Observação */}
          <div className="form-row">
            <div className="form-group" style={{ flex: 2 }}>
              <label>Complemento</label>
              <input
                type="text"
                name="complementoEnd"
                value={cliente.complementoEnd || ""}
                onChange={handleChange}
                placeholder="Digite o Complemento"
              />
            </div>
            <div className="form-group" style={{ flex: 4 }}>
              <label>Observação</label>
              <input
                type="text"
                name="observacao"
                value={cliente.observacao || ""}
                onChange={handleChange}
                placeholder="Digite a Observação"
              />
            </div>
          </div>

          {/* Painel de Processos */}
          <div className="painel-processos">
            <div className="form-group" style={{ flex: 1, paddingTop: 10 }}>
              <Form.Label style={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold', display: 'block' }}>Processos</Form.Label>
              {/* <div className="painel-processos"> */}
              <div className="d-flex flex-column gap-2 mt-2">
                {/* <label>
                  <input
                    type="checkbox"
                    name="guardaDocumental"
                    checked={processosSelecionados.guardaDocumental}
                    onChange={handleCheckboxChange}
                  />
                  Guarda Documental
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="auditoria"
                    checked={processosSelecionados.auditoria}
                    onChange={handleCheckboxChange}
                  />
                  Auditoria
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="planejamento"
                    checked={processosSelecionados.planejamento}
                    onChange={handleCheckboxChange}
                  />
                  Planejamento Estratégico
                </label> */}
                {processosSelecionados.map((processo) => (
                  <Row key={processo.chave} className="py-1">
                    <Col md={4}>
                      <span>{processo.nome}</span>
                    </Col>
                    <Col md={2} className="text-start">
                      <Form.Check
                        type="switch"
                        id={`switch-${processo.chave}`}
                        name={processo.chave}
                        checked={processo.ativo}
                        onChange={handleSwitchChange}
                        className="switchProcessos"
                      />
                    </Col>
                  </Row>
                ))}
              </div>
            </div>
          </div>

          {/* Link de Cadastramento Externo */}
          {idClienteEditando && (
            <div className="mt-4 p-3 border rounded bg-light">
              <label style={{ fontWeight: "bold" }}>Link de Cadastramento Externo de Operador</label>
              <div className="d-flex align-items-center mt-2">
                <input
                  type="text"
                  className="form-control"
                  value={`http://www.pentagov.com.br/cadexterno/${idClienteEditando}`}
                  readOnly
                />
                <button
                  className="btn btn-primary ms-2"
                  onClick={() => {
                    navigator.clipboard.writeText(`http://www.pentagov.com.br/cadexterno/${idClienteEditando}`);
                    Swal.fire({
                      toast: true,
                      position: "top-end",
                      icon: "success",
                      title: "Link copiado!",
                      showConfirmButton: false,
                      timer: 2000
                    });
                  }}
                >
                  Copiar
                </button>
              </div>
            </div>
          )}

          <button style={{ marginTop: 20, display: 'block' }} onClick={salvarCliente}>Salvar Cliente</button>
        </div>


        <br />
        <div>
          <GridRegistros
            registros={clientes}
            chaveId="IDCliente"
            onEdit={handleEdit}
            onDelete={handleDelete}
            ocultarCampos={["observacao", "logradouro", "numeroEnd", "bairro", "complementoEnd", "dataCadastro"]}
          />
        </div>
      </div>
    </div >
  );
};

export default CadastroCliente;
